import PageLayout from 'pages/People/PageLayout';
import PageProvider from 'pages/People/PageProvider';

const People = (props) => {
    return (
        <PageProvider {...props}>
            <PageLayout />
        </PageProvider>
    );
};

export default People;
